//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable object-property-newline */
import AQModalDlg from "@/components/Generics/AQModalDlg/AQModalDlg.vue";
import QfColumnEntry from "./qf-column-entry.vue";

export default {
    name: "QfMColumnEditor",
    components: { AQModalDlg, QfColumnEntry },
    props: {
        columns: { type: Array, default: () => [] }
    },
    data() {
        return {
            list: [],
            drag: false,
            localShow: true,
            localColumns: null,
            actions: [{ label: "Update", name: "set", disable: false }],
            dragOptions: {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            }
        };
    },
    watch: {
        columns: {
            handler(val) {
                this.localColumns = val || [];
            },
            immediate: true
        }
    },
    beforeMount() {
        if (this.columns.length) {
            this.updateList();
        } else {
            const _meta = {
                format: { dataType: "", type: "", decimal: ".", thousands: "," }
            };

            this.localColumns.push({
                headerName: "", field: "", sortable: true, filter: false, resizable: true,
                flex: 1, previewAttach: false, checkboxSelection: false, get: null, _meta,
                wrapText: false, autoHeight: false
            });
            this.updateList(true);
        }
    },
    methods: {
        startDrag() {
            this.drag = true;
        },
        updateList(setFocus) {
            this.list = this.localColumns.map((_, index) => ({ index, order: index, focus: false }));

            if (setFocus) {
                this.list[this.list.length - 1].focus = true;
            }
        },
        modalAction(action) {
            if (action.simple === "hide") {
                this.localShow = action.detailed === "action_backdrop";
            } else if (action.simple === "action") {
                if (action.detailed === "set") {
                    const orderedColumns = [];

                    this.list.forEach(({ index }) => {
                        orderedColumns.push(this.localColumns[index]);
                    });

                    this.$emit("update", orderedColumns);
                    this.localShow = false;
                }
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        addColumn() {
            const _meta = {
                format: { dataType: "", type: "", decimal: ".", thousands: "," }
            };

            this.localColumns.push({
                headerName: "", field: "", sortable: true, filter: false, resizable: true, flex: 1,
                checkboxSelection: false, floatingFilter: false, get: null, _meta, wrapText: false,
                previewAttach: false, autoHeight: false
            });

            this.list.push({ index: this.localColumns.length - 1, order: this.list.length });
            this.onFocus(this.list.length - 1);
        },
        onFocus(index) {
            // eslint-disable-next-line no-return-assign
            this.list.forEach((entry, idx) => entry.focus = idx === index);
        },
        removeEntry(index) {
            this.list.splice(index, 1);
        }
    }
};
